import { render, staticRenderFns } from "./NewAssetDialog.vue?vue&type=template&id=67c18f42"
import script from "./NewAssetDialog.vue?vue&type=script&lang=js"
export * from "./NewAssetDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports